/* Single source of truth for VoraStyle category/subcategory taxonomy.
 *
 * Phase 3 (Feb 2026): platform is exclusively Interior Design & Aesthetics.
 * Fashion category retired. "interior" kept on disk as DB value (surfaced
 * as "Home"); "design_elements" stays as DB value.
 *
 * Phase-3 sub-cat redesign:
 *  - HOME: Spaces · Seating · Tables · Lighting · Textiles · Atmospheres · Palettes
 *  - DESIGN ELEMENTS: People & Print · Text · Shapes · Frames · Magazine Articles · Writings
 */

export const CATEGORIES = [
  { value: "interior",        label: "Home" },
  { value: "design_elements", label: "Design Elements" },
];

export const SUBCATEGORIES = {
  interior: [
    { value: "spaces",      label: "Spaces" },
    { value: "seating",     label: "Seating" },
    { value: "tables",      label: "Tables" },
    { value: "lighting",    label: "Lighting" },
    { value: "textiles",    label: "Textiles" },
    { value: "atmospheres", label: "Atmospheres" },
    { value: "palettes",    label: "Palettes" },
  ],
  design_elements: [
    { value: "people_print",       label: "People & Print" },
    { value: "text",               label: "Text" },
    { value: "shapes",             label: "Shapes" },
    { value: "frames",             label: "Frames" },
    { value: "magazine_articles",  label: "Magazine Articles" },
    { value: "writings",           label: "Writings" },
  ],
};

export const ALL_CATEGORY_VALUES = CATEGORIES.map(c => c.value);
export const ALL_SUBCATEGORY_VALUES = Object.values(SUBCATEGORIES).flat().map(s => s.value);

export function getSubcats(category) {
  return SUBCATEGORIES[category] || [];
}

export function getCategoryLabel(value) {
  return CATEGORIES.find(c => c.value === value)?.label || value;
}
